import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Tabs } from 'antd';

import ReceivableSummaryStore from '../stores/ReceivableSummaryStore';
import ReceivableStore from '../stores/ReceivableStore';

import { pageSectionTitle } from '../util/Style';

import ReceivableGrid from './ReceivableGrid';
import DueConsolidation from './DueConsolidation';

const { TabPane } = Tabs;

const tabBarStyle = {
    fontWeight: "bold",
}

class ReceivableUI extends Component {

    constructor(props) {
        super(props);

        this.dailyStore = new ReceivableStore({ apiProxy: props.appStore.apiProxy, collectionType: "daily" });
        this.monthlyStore = new ReceivableStore({ apiProxy: props.appStore.apiProxy, collectionType: "monthly" });
        this.weeklyStore = new ReceivableStore({ apiProxy: props.appStore.apiProxy, collectionType: "weekly" });
        this.errorStore = new ReceivableStore({ apiProxy: props.appStore.apiProxy, collectionType: "unknown" });
        this.summaryStore = new ReceivableSummaryStore({ apiProxy: props.appStore.apiProxy });
    }

    render() {
        return (
            <Tabs style={{paddingLeft:10,paddingRight:10}} defaultActiveKey="1" tabBarStyle={tabBarStyle} tabBarExtraContent={pageSectionTitle("Receivables")}>
                <TabPane tab="Summary" key="1">
                    <DueConsolidation appStore={this.props.appStore} title="Summary" store={this.summaryStore} />
                </TabPane>
                <TabPane tab="Daily" key="2">
                    <ReceivableGrid appStore={this.props.appStore} title="Daily" store={this.dailyStore} />
                </TabPane>
                <TabPane tab="Weekly" key="3">
                    <ReceivableGrid appStore={this.props.appStore} title="Weekly" store={this.weeklyStore} />
                </TabPane>
                <TabPane tab="Monthly" key="4">
                    <ReceivableGrid appStore={this.props.appStore} title="Monthly" store={this.monthlyStore} />
                </TabPane>
                <TabPane tab="Error" key="5">
                    <ReceivableGrid appStore={this.props.appStore} title="Error" store={this.errorStore} />
                </TabPane>

            </Tabs>
        )
    }
}

export default observer(ReceivableUI)
